<template lang="pug">   
  v-card(
    height='100%'
    width='100%'
    :flat='lockStatus'
    :class='cardClass'
    :disabled='isDisable'
    @click='openGame (data)'
  )
    v-row(no-gutters='')
      v-avatar.mx-2(size='23px')
        v-img(:src='icon_image_url')
      v-col
        h5 {{ data.name }}
    h3.mx-3 {{ timeCountDown }}
    h6.mx-3(
      v-if='openStatus && !lockStatus'
    ) {{ $t('open-stake-time') }} : {{ data.opened_at }}
    h6.mx-3(
      v-else
    ) {{ $t('closed-stake-time') }} : {{ data.locked_at }}

</template> 
<script> 
import { ROUTE_GAME_LOTTO_DETAIL, ROUTE_INTERNAL_LOTTO } from '@/const/route'
import { imagePath } from '@/plugins/mapImage'
import { getTime, timeRemain, timeStampConvert } from '@/plugins/time'
import { classCardColor } from '@/const/gameId'
import * as c from '@/const/setTimeOutConfig'
const CLOSED_STATUS_ID = 3

export default {
  props: {
    msg: {
      type : Object,
      default : () => {}
    },
    typeId : {
      type : Number,
      default : () => 0
    }
  },   
  data () {
    return {
      data : {},
      timeCountDown : null,
      locked_timestamp : null,
      opened_timestamp :null,
      closed_timestamp : null,
      icon_image_url : null,
      gameId : null,
      lockStatus : true,
      closeStatus : true, 
      openStatus : false,
      isDisable: false
    }
  },

  computed : {
    cardClass () {
      let lockText = this.lockStatus && !this.closeStatus ? 'blurColor' : ''
      let closeText = this.closeStatus ? 'CloseStock' 
      : this.seperateThaiStock() ? 'Stock' 
      : classCardColor(this.typeId)
      return `py-3 ${lockText} ${closeText}` 
    }
  },

  async created () {     
    this.data = this.msg
    this.gameId = this.msg.game_id
    this.icon_image_url = imagePath(this.msg.game_id, this.msg.name) 
    this.closed_timestamp = timeStampConvert(this.msg.closed_at)-c.CLOSEGAMEBEFORE
    this.locked_timestamp= timeStampConvert(this.msg.locked_at)
    this.opened_timestamp = timeStampConvert(this.msg.opened_at)
    const roomStatus = this.msg.room_status
    const isClosedStatus = roomStatus.id === CLOSED_STATUS_ID
    
    if(timeRemain(this.locked_timestamp)<0 || isClosedStatus){
      this.timeCountDown = isClosedStatus ? roomStatus.name : this.$t('closed-stake')
      if(!isClosedStatus) {
        this.closeStatus = timeRemain(this.closed_timestamp) > 0 ? false : true
      } else { 
        this.isDisable = true
      }
    } else {
      this.timeCountDown = getTime(timeRemain(this.locked_timestamp))
      this.lockStatus=false
      this.closeStatus = false
    } 
    if(!this.closeStatus) this.countDownTimer()  
  },

  methods : {     
    seperateThaiStock () { 
      //thai lotto game id
      return [184,183].includes(this.gameId)
    },
    openGame () { 
      this.$ga.event('Button', 'OpenGame', 'LottoPage',this.data.name)

      if(!this.data.uuid) {
        return
      } 

      this.$router.push({ 
        name: ROUTE_GAME_LOTTO_DETAIL, 
        query: { id: this.data.uuid } 
      }).catch(()=>{});    
    },   

    countDownTimer () {     
      if(timeRemain(this.closed_timestamp) > 0 && this.$route.name === ROUTE_INTERNAL_LOTTO) {
        setTimeout(() => { 
          if(timeRemain(this.opened_timestamp)>0){
            this.timeCountDown = this.$t('coming-soon')
            this.openStatus = true
          } else if(timeRemain(this.locked_timestamp) >0) {
            this.timeCountDown = getTime(timeRemain(this.locked_timestamp))
            this.openStatus = false
          } else { 
            this.timeCountDown = this.$t('closed-stake')
            this.lockStatus = true
            this.openStatus = false
          }
          this.countDownTimer()
        }, c.COUNTDOWNONESEC)
      } else if(!this.closeStatus) {  
        this.closeStatus = true   
        if(this.$route.name === ROUTE_INTERNAL_LOTTO) this.$emit('sortdata')
      }
    },
  } 
}
</script>  